import type { FC } from 'react';

import { FacebookBoxLine, LinkedinBoxLine } from 'components/icons/Logos';
import { ABOUT_LINKS, STAY_UPDATED_LINKS } from 'navigation/footerNavigation';
import IconButton from 'components/atoms/IconButton';
import { ButtonModes } from 'constants/ButtonModes';
import { FooterLinkList } from 'components/molecules/FooterLinkList';
import { GO_TO_LINKS } from 'navigation/mainNavigation';
import { StyledLink } from 'components/atoms/StyledLink';

export const Footer: FC = () => (
  <footer className="bg-hrg-red-70">
    <div className="px-6 pt-12 mx-auto mb-24 max-w-page-content">
      <h2 className="mb-4 h5">Follow us</h2>
      <div className="flex gap-3">
        <IconButton
          mode={ButtonModes.secondaryBlack}
          aria-label="Hurtigruten Norge Facebook"
          href="https://www.facebook.com/HurtigrutenNorge"
          icon={FacebookBoxLine}
          className="px-0"
        />
        <IconButton
          mode={ButtonModes.secondaryBlack}
          aria-label="Hurtigreutn Group Linkedin"
          href="https://www.linkedin.com/company/hurtigrutengroup"
          icon={LinkedinBoxLine}
          className="px-0"
        />
      </div>
    </div>
    <nav className="grid grid-cols-1 gap-12 px-6 mx-auto mb-12 tablet:grid-cols-2 laptop:grid-cols-3 max-w-page-content">
      <FooterLinkList title="About" links={ABOUT_LINKS} />
      <FooterLinkList title="Stay updated" links={STAY_UPDATED_LINKS} />
      <FooterLinkList title="Go to" links={GO_TO_LINKS} externalLinks />
    </nav>
    <div className="border-t border-hrg-black-60">
      <div className="grid grid-cols-1 px-6 py-12 mx-auto gap-y-4 gap-x-12 tablet:grid-cols-2 laptop:grid-cols-3 max-w-page-content">
        <p className="body">© {new Date().getFullYear()} Hurtigruten Group</p>
        <div className="flex flex-col laptop:col-span-2 gap-y-4 gap-x-6 tablet:flex-row">
          <StyledLink href="https://global.hurtigruten.com/practical-information/statement-of-privacy/">
            Privacy statement
          </StyledLink>
          <StyledLink className="ot-sdk-show-settings">
            Manage Preferences
          </StyledLink>
        </div>
      </div>
    </div>
  </footer>
);
